import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, {useEffect, useState } from "react";
import SuccessModal from "../../SuccessModal";
import { addBrandBanner, updateBrandBanner } from "../../../services/BrandBanner/BrandBanner";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";

const BrandBannerAddModal = ({
  brandBannerAddModalVisible,
  setBrandBannerAddModalVisible,
  sendDataToBannerList,
  brandId,
  storeId,
  selectedBrandBanner,
}) => {
  const [selectedImage, setSelectedImage] = useState("");
  const [location, setLocation] = useState("");
  const [fileName, setFileName] = useState("");
  const [locationError, setLocationError] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [submitButtonPressed, setSubmitButtonPressed] = useState(false);
  const [imageError, setImageError] = useState("");
  const [bannerId, setBannerId] = useState("")

  const handleModalClose = () => {
    setSelectedImage("");
    setBannerId("");
    setLocation("");
    setFileName("");
    setLocationError("");
    setImageError("");
    setBrandBannerAddModalVisible(false);
    setSubmitButtonPressed(false);
  };

   useEffect(() => {
     if (selectedBrandBanner) {
       setLocation(selectedBrandBanner.location);
       setBannerId(selectedBrandBanner.id);
     }
   }, [selectedBrandBanner]);

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];

    if (!file) return;

    // Check size (500 KB)
    const fileSizeKB = file.size / 1024;
    if (fileSizeKB > 500) {
      setImageError("Image size must be less than 500 KB");
      setSelectedImage(null);
      setFileName("");
      return;
    }

    setImageError(""); // Clear previous error
    setFileName(file.name);

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleBannerUpload = (event) => {
    event.preventDefault();

    let isValid = true;
    if (location === "") {
      setLocationError("Location is Required");
      isValid = false;
    }

    if (isValid) {
      setSubmitButtonPressed(true);
      const fileInput = event.target.querySelector('input[type="file"]');
      const imageFile = fileInput.files[0];

      if (!imageFile) {
        console.error("No file selected");
        return;
      }

      // Generate a custom name for the image
      const date = new Date();
      const customFileName = `Brand-Images-${location}-${Math.floor(
        date.getSeconds() / 2
      )}.jpg`;

      // Create a new file object with the custom name
      const renamedImageFile = new File([imageFile], customFileName, {
        type: imageFile.type,
      });

      updateBrandBanner(brandId, bannerId, renamedImageFile)
        .then((response) => {
          if (response.data.status === true) {
            setModalVisible(true);
            setModalStatus(true);
            setModalText(response.data.message);
          } else {
            setModalVisible(true);
            setModalStatus(false);
            setModalText(response.data.message);
          }

          setSelectedImage("");
          setLocation("");
          setFileName("");
          setLocationError("");
          setImageError("");
          setBrandBannerAddModalVisible(false);
          setSubmitButtonPressed(false);
          sendDataToBannerList({
            success: true,
          });
        })
        .catch((error) => {
          console.error("Upload failed", error);
          setModalVisible(true);
          setSubmitButtonPressed(false);
          setModalStatus(false);
        });
    }
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={brandBannerAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!brandBannerAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"images/plus.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                UPDATE BRAND IMAGES
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4 my-2">
                <form onSubmit={handleBannerUpload}>
                  <div className="row mb-3">
                    <div
                      className="col-md-12"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <label for="file-upload" className="custom-file-upload">
                          <i className="pi pi-upload"></i> Select Image
                        </label>
                        <input
                          id="file-upload"
                          type="file"
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                      </div>
                      <div>
                        <img
                          src={
                            selectedImage
                              ? selectedImage
                              : // : garmentPreviousLogo
                                // ? `data:image/png;base64,${garmentPreviousLogo}`
                                ""
                          }
                          alt=""
                          style={{
                            maxWidth: "100px",
                            maxHeight: "100px",
                          }}
                        />
                        {fileName && (
                          <p
                            style={{
                              alignSelf: "center",
                              fontSize: 14,
                              fontWeight: 600,
                              margin: 10,
                            }}
                          >
                            {fileName}
                          </p>
                        )}

                        {imageError && (
                          <p style={{ color: "red", fontWeight: 600 }}>
                            {imageError}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mx-4 mt-4 flex-1">
                      <FloatLabel>
                        <InputText
                          id="location"
                          value={location}
                          onChange={(e) => {
                            setLocation(e.target.value);
                            setLocationError("");
                          }}
                          className="w-full text-xl p-2 border-round-xl shadow-2"
                          style={{
                            backgroundColor: "#fff",
                          }}
                          disabled={true}
                        />
                        {locationError && (
                          <p
                            className="text-lg font-normal"
                            style={{ color: "red" }}
                          >
                            {locationError}
                          </p>
                        )}

                        <label
                          htmlFor="location"
                          className="text-lg"
                          style={{ color: "blue" }}
                        >
                          location <span style={{ color: "red" }}>*</span>
                        </label>
                      </FloatLabel>
                    </div>
                  </div>
                  {selectedImage && (
                    <div className="col-md-12 text-center">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={submitButtonPressed}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus === true ? "success" : false}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default BrandBannerAddModal;
